
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/khivraj-elixir",
      function () {
        return require("private-next-pages/case-study/khivraj-elixir.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/khivraj-elixir"])
      });
    }
  